<template>
  <Teleport to="body">
    <div v-show="modalActive" class="modal-bg">
      <div class="modal" :class="size">
        <div class="modal-header">
          <div class="tabs">
            <h2>{{ modalTitle }}</h2>
            <div style="position: relative; margin-left: 10px">
              <div class="btn-box" v-show="hasLang">
                <div id="btn" :style="{ left: btnPosition }"></div>
                <button @click="moveLeft" :style="leftButtonStyle">vn</button>
                <button @click="moveRight" :style="rightButtonStyle">en</button>
              </div>
            </div>
          </div>

          <i @click="$emit('close')" class="close-icon fa-solid fa-xmark"></i>
        </div>
        <div class="modal-content" ref="modalContent">
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script>
export default {
  props: {
    modalActive: {
      type: Boolean,
      require: false,
      default: false
    },
    size: {
      type: String,
      require: false,
      default: 'default'
    },
    modalTitle: {
      type: String,
      require: false,
      default: ''
    },
    hasLang: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  emits: ['close', 'vnTab', 'enTab'],
  data () {
    return {
      btnPosition: '0px', // Start position of the button
      activeTab: 'left'
    }
  },
  computed: {
    leftButtonStyle () {
      return {
        color: this.activeTab === 'left' ? '#fff' : '#000'
      }
    },
    rightButtonStyle () {
      return {
        color: this.activeTab === 'right' ? '#fff' : '#000'
      }
    }
  },
  methods: {
    moveLeft () {
      this.btnPosition = '0px' // Move to the left
      this.$emit('vnTab')
      this.activeTab = 'left'
    },
    moveRight () {
      this.btnPosition = '47px' // Move to the right
      this.$emit('enTab')
      this.activeTab = 'right'
    }
  },
  watch: {
    modalActive (newVal) {
      if (newVal) {
        // Scroll to top when modal becomes active
        this.btnPosition = '0px'
        this.activeTab = 'left'
        this.$nextTick(() => {
          this.$refs.modalContent.scrollTop = 0
        })
      }
    }
  }
}
</script>
<style scoped>
  .modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    z-index: 4;
  }

  .modal {
    padding: 16px;
    background: #fff;
    width: 700px;
    align-self: center;
    border-radius: 12px;
  }

  .modal-header {
    height: 35px;
    border-bottom: 2px solid #d9d9d9;
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
  }

  .tabs {
    display: flex;
  }

  .btn-box {
    border: 2px solid #ababab;
    position: absolute;
    display: flex;
    justify-content: space-between;
    border-radius: 30px;
    width: 100px;
    margin: 0px auto;
  }

  .tabs button {
    outline: none;
    border: none;
    background: transparent;
    border: 0;
    text-align: center;
    border-radius: 30px;
    padding: 5px 17.5px;
    position: relative;
  }

  #btn {
    position: absolute;
    width: 50px;
    height: 100%;
    background-color: #0298cf;
    border-radius: 30px;
    transition: 0.5s;
  }

  .modal-content {
    max-height: 80vh; /* Đặt max-height */
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 15px;
  }

  .small {
    width: 300px;
  }

  .default {
    width: 600px;
  }

  .large {
    width: 1000px;
  }

  .close-icon {
    caret-color: transparent;
    cursor: pointer;
    transition: color 0.3s ease-out;
  }

  .close-icon:hover {
    color: red;
  }
</style>
